import { render, staticRenderFns } from "./ConfigSincronizacaoModal.vue?vue&type=template&id=735308cf"
import script from "./ConfigSincronizacaoModal.vue?vue&type=script&lang=js"
export * from "./ConfigSincronizacaoModal.vue?vue&type=script&lang=js"
import style0 from "./ConfigSincronizacaoModal.vue?vue&type=style&index=0&id=735308cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports